<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <Header :activeIndex="7" />
      </div>
      <div class="hengtiao">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">个人信息与能力测评报告</div>
      </div>
    </div>
    <div class="hengtiao1" v-if="!isMobile">
    </div>
    <div class="hengtiao" v-if="!isMobile">
      <div class="xiangji"><i class="el-icon-camera"></i></div>
      <div class="gerenxinxi">个人信息与能力测评报告</div>
    </div>
    <div style="display:flex;">
      <Header :activeIndex="7" style="position: fixed;margin-top:58px;" v-if="!isMobile" />
      <div class="head02">
        <div class="personal-info-page">
          <div class="section">
            <h2>一、基本信息</h2>
            <div class="info-row">
              <label>姓名：</label>
              <span>{{ basicInfo.userName }}</span>
            </div>
            <div class="info-row">
              <label>性别：</label>
              <span>{{ basicInfo.gender }}</span>
            </div>
            <div class="info-row">
              <label>出生日期：</label>
              <span>{{ formatDate(basicInfo.birthday) }}</span>
            </div>
            <div class="info-row">
              <label>民族：</label>
              <span>{{ basicInfo.ethnicity }}族</span>
            </div>
            <div class="info-row">
              <label>兴趣爱好：</label>
              <span>{{ basicInfo.hobbies }}</span>
            </div>
            <div class="info-row">
              <label>不良记录：</label>
              <span v-if="basicInfo.negativeRecord">{{ basicInfo.negativeRecord }}</span>
              <span v-else>无</span>
            </div>
            <div class="info-row">
              <label>联系电话：</label>
              <span>{{ basicInfo.phoneNumber }}</span>
            </div>
            <div class="info-row">
              <label>邮箱：</label>
              <span>{{ basicInfo.email }}</span>
            </div>
          </div>

          <div class="section">
            <h2>二、学习能力测评报告</h2>
            <div class="info-row">
              <label>入学年份：</label>
              <span>{{ formatDate(collegeReport.admissionDate) }}</span>
            </div>
            <div class="info-row">
              <label>毕业年份：</label>
              <span>{{ formatDate(collegeReport.graduationDate) }}</span>
            </div>
            <div class="info-row">
              <label>毕业院校：</label>
              <span>{{ collegeReport.almaMater }}</span>
            </div>
            <div class="info-row">
              <label>学历：</label>
              <span>{{ collegeReport.degree }}</span>
            </div>
            <div class="info-row">
              <label>专业：</label>
              <span>{{ collegeReport.major }}</span>
            </div>
            <div class="info-row">
              <label>学业成绩：</label>
              <span>{{ collegeReport.academic }}</span>
            </div>
            <div class="info-row">
              <label>学业成绩排名：</label>
              <span v-if="collegeReport.gradeRanking === '1'">10%以内</span>
              <span v-else-if="collegeReport.gradeRanking === '2'">30%以内</span>
              <span v-else-if="collegeReport.gradeRanking === '3'">50%以内</span>
              <span v-else-if="collegeReport.gradeRanking === '4'">50%以下</span>
            </div>
            <div class="info-row">
              <label>证书、职称与奖励：</label>
              <span>{{ collegeReport.certificate }}</span>
            </div>
            <div class="chart-container">
              <!-- 学习背景条（百分比） -->
              <div class="bar-container">
                <div class="bar-label">学习背景:</div>
                <div class="bar-background">
                  <div class="bar-fill background-bar" :style="{ width: learningBackground + '%' }"></div>
                </div>
                <div class="bar-value">{{ learningBackground }}%</div>
              </div>

              <!-- 学习能力条（小数） -->
              <div class="bar-container">
                <div class="bar-label">学习能力:</div>
                <div class="bar-background">
                  <div class="bar-fill ability-bar" :style="{ width: learningAbility + '%' }"></div>
                </div>
                <div class="bar-value">{{ learningAbility }}%</div>
              </div>
            </div>
          </div>
          <div class="section">
            <h2>三、工作及实习经历</h2>
            <div class="info-row">
              <label>实习经历：</label>
              <span>{{ workExperience.internship }}</span>
            </div>
            <div class="info-row">
              <label>期待工作地点：</label>
              <span>{{ workExperience.preferredLocation }}</span>
            </div>
            <div class="info-row">
              <label>霍兰德测试结果：</label>
              <span>{{ jieguo }}</span>
            </div>
            <div class="holland-chart-container">
              <div v-for="(item) in scaledScores" :key="item.type" class="single-chart">
                <div class="chart-header">
                  <span class="type-label" v-if="item.type === 'A'">创造能力、审美能力</span>
                  <span class="type-label" v-else-if="item.type === 'C'">执行能力、细致能力</span>
                  <span class="type-label" v-else-if="item.type === 'E'">领导能力、说服能力</span>
                  <span class="type-label" v-else-if="item.type === 'I'">分析能力、探索能力</span>
                  <span class="type-label" v-else-if="item.type === 'R'">动手能力、问题解决能力</span>
                  <span class="type-label" v-else-if="item.type === 'S'">沟通能力、共情能力</span>
                  <span class="score-label">得分: {{ (item.scaledScore / 10 * 100).toFixed(0) }}%</span>
                </div>
                <div class="chart-bar-container">
                  <div class="chart-bar-bg"></div>
                  <div class="chart-bar-progress" :style="{
                    width: `${item.scaledScore * 10}%`,
                    backgroundColor: getColor(item.type),
                  }"></div>
                  <div class="chart-ticks">
                    <span v-for="i in 11" :key="i" class="tick" :style="{ left: `${(i - 1) * 10}%` }">
                      {{ i - 1 }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="section">
            <h2>四、匹配度分析</h2>
            <div class="chart-container">
              <div class="bar-container">
                <div class="bar-label">证书匹配度:</div>
                <div class="bar-background">
                  <div class="bar-fill cert-bar"
                    :style="{ width: dimensionWiseMatching.certificateMatchingResult + '%' }">
                  </div>
                </div>
                <div class="bar-value">{{ dimensionWiseMatching.certificateMatchingResult }}%</div>
              </div>

              <div class="bar-container">
                <div class="bar-label">学历匹配度:</div>
                <div class="bar-background">
                  <div class="bar-fill education-bar"
                    :style="{ width: dimensionWiseMatching.educationMatchingResult + '%' }">
                  </div>
                </div>
                <div class="bar-value">{{ dimensionWiseMatching.educationMatchingResult }}%</div>
              </div>

              <div class="bar-container">
                <div class="bar-label">期望匹配度:</div>
                <div class="bar-background">
                  <div class="bar-fill expecta-bar"
                    :style="{ width: dimensionWiseMatching.expectationMatchingResult + '%' }"></div>
                </div>
                <div class="bar-value">{{ dimensionWiseMatching.expectationMatchingResult }}%</div>
              </div>

              <div class="bar-container">
                <div class="bar-label">经验匹配度:</div>
                <div class="bar-background">
                  <div class="bar-fill experience-bar"
                    :style="{ width: dimensionWiseMatching.experienceMatchingResult + '%' }">
                  </div>
                </div>
                <div class="bar-value">{{ dimensionWiseMatching.experienceMatchingResult }}%</div>
              </div>

              <div class="bar-container">
                <div class="bar-label">兴趣匹配度:</div>
                <div class="bar-background">
                  <div class="bar-fill inter-bar" :style="{ width: dimensionWiseMatching.interestMatchingResult + '%' }">
                  </div>
                </div>
                <div class="bar-value">{{ dimensionWiseMatching.interestMatchingResult }}%</div>
              </div>

              <div class="bar-container">
                <div class="bar-label">专业匹配度:</div>
                <div class="bar-background">
                  <div class="bar-fill major-bar" :style="{ width: dimensionWiseMatching.majorMatchingResult + '%' }">
                  </div>
                </div>
                <div class="bar-value">{{ dimensionWiseMatching.majorMatchingResult }}%</div>
              </div>

              <div class="bar-container">
                <div class="bar-label">技能匹配度:</div>
                <div class="bar-background">
                  <div class="bar-fill skill-bar" :style="{ width: dimensionWiseMatching.skillMatchingResult + '%' }">
                  </div>
                </div>
                <div class="bar-value">{{ dimensionWiseMatching.skillMatchingResult }}%</div>
              </div>
            </div>
          </div>
        </div>
        <div class="shoucang">
          <el-switch v-model="star" active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"
            active-text="已收藏" inactive-text="未收藏" @change="handleStarChange">
          </el-switch>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from './qiyeHeader.vue';
import Footer from './Footer.vue'
export default {
  name: 'usereport',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      userId: sessionStorage.getItem("linshiUserId"),
      qiyeId: sessionStorage.getItem("qiyeId"),
      talentId: sessionStorage.getItem("talentId"),
      applicantData: [],
      basicInfo: {
        userName: '',
        gender: '',
        birthday: '',
        ethnicity: '',
        phoneNumber: '',
        email: '',
        hobbies: '',
        negativeRecord: ''
      },
      // 学习能力测评报告
      collegeReport: {
        admissionDate: '',
        graduationDate: '',
        almaMater: '',
        degree: '',
        major: '',
        academic: '',
        gradeRanking: '',
        certificate: ''
      },
      // 工作及实习经历
      workExperience: {
        internship: '',
        preferredLocation: '',
        typeScore: '',
      },
      BASE_URL: 'https://zhiyedashi.com/info',
      BASE_URL1: 'https://zhiyedashi.com/career',
      BASE_URL2: 'https://zhiyedashi.com/school',
      BASE_URL3: 'https://zhiyedashi.com/job',
      // BASE_URL: 'http://192.168.2.8:8206',
      // BASE_URL1: 'http://192.168.2.8:8203',
      // BASE_URL2: 'http://192.168.2.8:8205',
      // BASE_URL3: 'http://192.168.2.8:8204',
      parsedScores: [],
      scaledScores: [],
      jieguo: '',
      learningBackground: 0,
      learningAbility: 0,
      dimensionWiseMatching: {
        certificateMatchingResult: 0, // 证书匹配度
        educationMatchingResult: 0, // 学历匹配度
        expectationMatchingResult: 0, // 期望匹配度
        experienceMatchingResult: 0, // 经验匹配度
        interestMatchingResult: 0, // 兴趣匹配度
        majorMatchingResult: 0, // 专业匹配度
        skillMatchingResult: 0, // 技能匹配度
      },
      rawMatchingResults: [],
      star: localStorage.getItem("star"),
      jobName: localStorage.getItem("jobName"),
      isMobile: false
    }
  },
  created() {
    // 1. 判断关键数据是否存在
    if (!this.qiyeId) {
      // 2. 提前返回，跳过后续所有代码
      console.warn('关键数据未获取到，停止执行后续逻辑');
      this.$router.push('/')
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.selectUserInfo()
    this.selectResumes()
    this.careerresult()
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleStarChange(value) {
      fetch(`${this.BASE_URL3}/admin/talent/updateTalent`, {
        method: 'post',
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `id=${this.talentId}`
      })
        .then(res => res.json())
        .then(data => {
          // console.log("修改成功", data);
          if (data.data === '取消收藏成功') {
            this.$router.push('/downloadresume');
          }
        })
        .catch(error => {
          console.error("修改失败，原因是", error)
        })
    },
    getColor(type) {
      const colors = {
        A: '#FF6B6B',
        C: '#4ECDC4',
        E: '#FFD166',
        I: '#6A0572',
        R: '#06D6A0',
        S: '#118AB2',
      };
      return colors[type] || '#999';
    },
    careerresult() {
      fetch(`${this.BASE_URL1}/admin/career/result/selectUserId`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `userId=${this.userId}`
      })
        .then(res => res.json())
        .then(data => {
          this.jieguo = data.data[0].result
          this.workExperience.typeScore = data.data[0].typeScore
          // console.log(this.jieguo);
          this.parseScores();
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        });
    },
    parseScores() {
      if (!this.workExperience.typeScore) {
        this.parsedScores = [];
        return;
      }
      this.parsedScores = this.workExperience.typeScore.split(';').map(item => {
        const [type, score] = item.split(':');
        return { type, originalScore: parseInt(score) };
      });
      // 3. 数据解析完成，调用计算方法
      this.calculateScaledScores();
    },
    // 3. 计算缩放后的分数
    calculateScaledScores() {
      this.scaledScores = this.parsedScores.map(item => {
        const scaled = Math.round((item.originalScore / 7) * 10); // 遇5进1
        return {
          ...item,
          scaledScore: scaled,
        };
      });
    },
    formatDate(dateString) {
      return dateString.split('T')[0];
    },
    selectUserInfo() {
      // 根据userId 去查询所有信息
      fetch(`${this.BASE_URL}/admin/user/info/selectUserInfo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `userId=${this.userId}`
      })
        .then(res => res.json())
        .then(data => {
          this.basicInfo = data.data
          this.selectpipei()
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        });
    },
    selectpipei() {
      // console.log("this.talentId", this.talentId);
      fetch(`${this.BASE_URL3}/admin/talent/selectUser`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `talentId=${this.talentId}`
      })
        .then(res => res.json())
        .then(data => {
          this.applicantData = JSON.parse(data.data)
          if (this.applicantData) {
            this.rawMatchingResults = this.applicantData;
            // console.log("1", this.rawMatchingResults);
            this.areasImprovements()
          } else {
            console.error("未找到匹配的求职者");
          }
        })
    },
    areasImprovements() {
      this.dimensionWiseMatching = {
        certificateMatchingResult: this.rawMatchingResults.Certificate_matching_result || 0,
        educationMatchingResult: this.rawMatchingResults.Education_matching_result || 0,
        expectationMatchingResult: this.rawMatchingResults.Expectation_matching_result || 0,
        experienceMatchingResult: this.rawMatchingResults.Experience_matching_result || 0,
        interestMatchingResult: this.rawMatchingResults.Interest_matching_result || 0,
        majorMatchingResult: this.rawMatchingResults.Major_matching_result || 0,
        skillMatchingResult: this.rawMatchingResults.Skill_matching_result || 0
      };
    },
    selectResumes() {
      // 根据userId 去查询所有信息
      fetch(`${this.BASE_URL}/admin/resumes/selectResumes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `userId=${this.userId}`
      })
        .then(res => res.json())
        .then(data => {
          this.collegeReport = data.data
          this.workExperience = data.data
          this.collegeReport.certificate = JSON.parse(data.data.certificate).join("，");
          this.workExperience.internship = JSON.parse(data.data.internship).join("，");
          const dataArray = JSON.parse(data.data.academic);

          // 2. 转换为 "科目：分数，科目：分数" 格式
          this.collegeReport.academic = dataArray.map(item => `${item.subject}：${item.score}`).join("，");
          let scores = dataArray.map(item => parseFloat(item.score));

          // 2. 计算平均分
          this.learningAbility = parseFloat((scores.reduce((sum, score) => sum + score, 0) / scores.length).toFixed(0));
          this.selectRanking()
        })
        .catch(error => {
          console.error("查询失败2，原因是", error);
        });
    },
    selectRanking() {
      fetch(`${this.BASE_URL2}/admin/school/selectBaifenbi`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `schoolName=${this.collegeReport.almaMater}`
      })
        .then(res => res.json())
        .then(data => {
          this.learningBackground = (data * 100).toFixed(0)
        })
        .catch(error => {
          console.error("查询百分比失败，原因是", error);
        });
    },
  }
}
</script>
<style scoped>
.hengtiao1 {
  position: fixed;
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  z-index: 99;
}

.hengtiao {
  position: fixed;
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
  z-index: 99;
  margin-top: 8px;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.xiangji2 {
  font-weight: 900;
  font-size: 155px;
  border: 1px soild #DCDFE6;
}

.gerenxinxi {
  margin-left: 20px;
  font-weight: 700;
}

.holland-chart-container {
  font-family: Arial, sans-serif;
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}

.single-chart {
  margin-bottom: 25px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.type-label {
  font-size: 18px;
  font-weight: bold;
}

.score-label {
  font-size: 14px;
  color: #666;
}

.chart-bar-container {
  position: relative;
  height: 30px;
  background-color: #f0f0f0;
  border-radius: 15px;
  overflow: hidden;
}

.chart-bar-bg {
  position: absolute;
  width: 100%;
  height: 100%;
}

.chart-bar-progress {
  position: absolute;
  height: 100%;
  transition: width 0.3s ease;
}

.chart-ticks {
  position: absolute;
  top: 35px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.tick {
  position: absolute;
  transform: translateX(-50%);
  font-size: 12px;
  color: #999;
}

.personal-info-page {
  width: 800px;
  margin-left: 460px;
  padding: 20px;
  font-family: Arial, sans-serif;
  margin-top: 50px;
}

h1 {
  text-align: center;
  color: #333;
}

.section {
  margin-bottom: 30px;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 5px;
}

h2 {
  color: #444;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.info-row {
  display: flex;
  margin: 10px 0;
}

label {
  width: 150px;
  font-weight: bold;
  color: #555;
}

span {
  flex: 1;
  color: #333;
}

.chart-container {
  margin-top: 30px;
}

.bar-container {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.bar-label {
  width: 100px;
  text-align: right;
  margin-right: 15px;
  font-weight: bold;
}

.bar-background {
  flex-grow: 1;
  height: 20px;
  background-color: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  transition: width 0.5s ease;
}

/* 学习背景条颜色（绿色） */
.background-bar {
  background-color: #4CAF50;
}

/* 学习能力条颜色（蓝色） */
.ability-bar {
  background-color: #2196F3;
}

.cert-bar {
  background-color: #4A90E2;
}

.education-bar {
  background-color: #9C27B0;
}

.expecta-bar {
  background-color: #66BB6A;
}

.experience-bar {
  background-color: #FF9800;
}

.inter-bar {
  background-color: #FFEB3B;
}

.major-bar {
  background-color: #F44336;
}

.skill-bar {
  background-color: #8bc34a;
}

.bar-value {
  width: 50px;
  text-align: right;
  margin-left: 10px;
  font-weight: bold;
}

.el-switch__label * {
  font-size: 24px !important;
}

.shoucang {
  margin-top: 80px;
  font-size: 20px;
}

@media (max-width: 768px) {
  .shoucang {
    margin-top: 10px;
  }

  .head02 {
    display: flex;
    flex-direction: column;
    padding-top: 140px;
  }

  .logo {
    width: 50px;
  }

  .hengtiao {
    height: 50px;
    width: 100%;
    background-color: #3572e5;
    color: white;
    display: flex;
    align-items: center;
    position: static;
    margin-top: 0px;
  }

  .personal-info-page {
    width: 100%;
    margin-left: 0;
    padding: 10px 0px;
    margin-top: 0px;
    box-sizing: border-box;
  }

  .holland-chart-container {
    padding: 5px 0px;
  }

  .info-row {
    /* flex-direction: column; */
    margin: 15px 0;
  }

  label {
    width: 48%;
    margin-bottom: 5px;
  }

  span {
    width: 100%;
  }

  .bar-container {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }

  .bar-label {
    width: 100%;
    text-align: left;
    margin-right: 0;
    margin-bottom: 8px;
  }

  .bar-background {
    width: 100%;
    height: 25px;
  }

  .bar-value {
    width: 100%;
    text-align: left;
    margin-left: 0;
    margin-top: 5px;
  }

  .section {
    padding: 10px;
    margin-bottom: 20px;
  }

  h1 {
    font-size: 24px;
  }

  h2 {
    font-size: 18px;
  }

  .type-label {
    font-size: 16px;
  }

  .chart-bar-container {
    height: 25px;
  }

  .chart-header {
    flex-direction: column;
    gap: 5px;
  }

  .el-switch__label * {
    font-size: 18px !important;
  }
}</style>



// WEBPACK FOOTER //
// src/components/downreport.vue